
//```import saga efects
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

//```import Error Manager
import { ExceptionManager } from 'Core/logManager';

//```import constants types
import {
    INTEGRATIONS_DELETE_CEREBRUMX_REQUEST,
} from 'Redux/actionTypes';

import { endpoints } from 'Core/defaultValues';
import { clientQuery, clientMutation } from 'Core/data/GraphQLApi';
import {
    integrationsDeleteCerebrumXResult,
} from 'Redux/actions';


function* deleteCerebrumXIntegration({ payload }) {
    try {
        let { fleetId, companyIntegrationId } = payload
        let QUERY = `
            mutation deleteCompanyIntegration ($id: Int!) {
                result: deleteCompanyIntegration (id: $id)
            }
        `;
        let data = yield call(
            clientMutation,
            QUERY,
            {
                id: companyIntegrationId
            },
            endpoints.GRAPHQL_GENERAL,
        );

        if (data?.result) yield put(integrationsDeleteCerebrumXResult({ delete: true }))
        else yield put(integrationsDeleteCerebrumXResult({ error: 'delete-role' }))

    } catch (exc) {
        yield put(integrationsDeleteCerebrumXResult({ error: exc.error }))
        ExceptionManager(
            exc,
            "Modules/accounts/.components/deleteCerebrumXIntegration/redux/saga",
            "deleteCerebrumXIntegration",
        )
    }
}

function* watchMethods() {
    yield takeEvery(INTEGRATIONS_DELETE_CEREBRUMX_REQUEST, deleteCerebrumXIntegration);
}

export default function* rootSaga() {
    yield all([fork(watchMethods)]);
}